import {
  FETCHING_CUSTOMER_DETAILS,
  FETCHING_CUSTOMER_DETAILS_SUCCEEDED,
  FETCHING_CUSTOMER_DETAILS_FAILED,
  UPDATING_CUSTOMER_DETAILS,
  UPDATING_CUSTOMER_DETAILS_SUCCEEDED,
  UPDATING_CUSTOMER_DETAILS_FAILED,
} from "constants/actionTypes";

const initState = {
  externalInvoiceData: {
    fetching: false,
    fetched: false,
    updating: false,
    updated: false,
    error: null,
    items: [],
  },
};

function downloadInvoiceReducer(state = initState, action) {
  switch (action.type) {
    case FETCHING_CUSTOMER_DETAILS: {
      return Object.assign({}, state, {
        ...state,
        externalInvoiceData: {
          ...state.externalInvoiceData,
          fetching: true,
          error: null,
          items: [],
        },
      });
    }

    case FETCHING_CUSTOMER_DETAILS_SUCCEEDED: {
      var result = _.get(action, "payload");
      var invoiceList = _.get(result, "customerResponses");
      return Object.assign({}, state, {
        ...state,
        externalInvoiceData: {
          ...state.externalInvoiceData,
          fetching: false,
          fetched: true,
          error: null,
          items: invoiceList,
        },
      });
    }

    case FETCHING_CUSTOMER_DETAILS_FAILED: {
      let error = _.get(action, "payload.error");
      return Object.assign({}, state, {
        ...state,
        externalInvoiceData: {
          ...state.externalInvoiceData,
          fetching: false,
          fetched: true,
          error: error,
        },
      });
    }

    case UPDATING_CUSTOMER_DETAILS:
      return Object.assign({}, state, {
        ...state,
        externalInvoiceData: {
          ...state.externalInvoiceData,
          updated: false,
          updating: true,
          error: null,
        },
      });
    case UPDATING_CUSTOMER_DETAILS_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        externalInvoiceData: {
          ...state.externalInvoiceData,
          updated: true,
          updating: false,
          error: null,
        },
      });
    case UPDATING_CUSTOMER_DETAILS_FAILED: {
      let error = _.get(action, "payload.error");

      return Object.assign({}, state, {
        ...state,
        externalInvoiceData: {
          ...state.externalInvoiceData,
          updated: false,
          updating: false,
          error: error,
        },
      });
    }

    default:
      return state;
  }
}

export { downloadInvoiceReducer };
